import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";

const UIStateStatus = ({message}) => {

    return (

            <Grid
                container
                spacing={4}
                direction="column"
                alignItems="center"
                justify="center"
                style={{minHeight: '100vh'}}
            >
                <Grid item xs={12}>
                    <Typography component="h5">
                        <CircularProgress/>
                    </Typography>
                </Grid>
                <Grid item xs={12}>
                    <Typography component="h5">
                        {message}
                    </Typography>
                </Grid>
            </Grid>


    );
}

export default UIStateStatus;

